const { Alert } = require('react-bootstrap');
import React from 'react';

function ErrorMessage(props) {
  const { response } = props;
  const { code, message } = response;

  if (code === 1507) {
    return (
      <Alert bsStyle="warning" style={{ marginTop: 20 }}>
        <strong>We are unable to validate a new account with the information you provided.</strong>

        <p style={{ marginTop: 20 }}>
          For assistance, please contact Technical Support at <a href="tel:+1-800-236-5004">1-800-236-5004</a> Monday
          through Friday during business hours of 8:00 AM to 4:30 PM CST. You may also contact us at{' '}
          <a href="mailto:CustomerSupport@wbmi.com">CustomerSupport@wbmi.com</a>.
        </p>
      </Alert>
    );
  }

  return (
    <Alert bsStyle="danger" style={{ marginTop: 20 }}>
      <strong>Error</strong> {message}
    </Alert>
  );
}

export { ErrorMessage };
